import rolecatalogAPI from "../../api/rolecatalogAPI";
import { urlContexts } from "../../constants";

  export const getPermissions = async () => {
    const { data } = await rolecatalogAPI.get(
      `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/permission`
    );
  
    return data;
  };
  
  export const createPermissions = async (createInfo: any) => {
    const { data } = await rolecatalogAPI.post(
      `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/permission`,
      createInfo
    );
  
    return data;
  };
  
  export const updatePermissions = async (updateInfo: any) => {
    const { data } = await rolecatalogAPI.put(
      `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/permission/${updateInfo?.id}`,
      {
        ...updateInfo,
        id: undefined,
      }
    );
  
    return data;
  };
  
  export const deletePermissions = async (deleteInfo: any) => {
    const { data } = await rolecatalogAPI.delete(
      `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/permission/${deleteInfo?.id}`
    );
  
    return data;
  };
  
  export const reactivePermissions = async (reactiveInfo: any) => {
    const { data } = await rolecatalogAPI.put(
      `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/permission/${reactiveInfo?.id}/reactivate`
    );
  
    return data;
  };
